import React from 'react';

import { useEligibilityDetailsContainer } from './useEligibilityDetailsContainer';
import EligibilityDetails from '@components/individualPortal/eligibilityResults/EligibilityDetails';
import { IEligibilityDetailsContainerProps } from '@constants/individualPortal/eligibility/eligibility.types';

const EligibilityDetailsContainer = (props: IEligibilityDetailsContainerProps) => {
    const { processedEligibilityData, getBtnData, showActionNeeded, stateCode } = props;

    const { getEligibilityDetails, showVoterRegistration, ssapApplicationId, caseNumber } = useEligibilityDetailsContainer({
        showActionNeeded,
        stateCode,
    });

    return (
        <EligibilityDetails
            eligibilityDetails={getEligibilityDetails(processedEligibilityData)}
            btnData={getBtnData()}
            showVoterRegistration={showVoterRegistration}
            ssapApplicationId={ssapApplicationId}
            caseNumber={caseNumber}
        />
    );
};

export default EligibilityDetailsContainer;
